import { Colors } from 'src/components/theme'

export const CHART_COLORS = [Colors.redDark, Colors.yellowDark, Colors.greenDark]
export const DEMO_CHARTS_WIDTH_IN_PC = 60
export const DEMO_CHARTS_LEFT_MARGIN = 60
export const TABLE_ROW_ORDER: Record<string, { heading: string; total?: string; omissions: string[] }> = {
  Overview: {
    heading: 'Population',
    total: 'Population',
    omissions: ['Population', 'Population Growth: Current to 5YR'],
  },
  Households: {
    heading: 'Total Households',
    total: 'Total Households',
    omissions: ['Total Households'],
  },
  'Housing Units': {
    heading: 'Total Housing Units',
    total: 'Total Housing Units',
    omissions: ['Total Housing Units'],
  },
  Age: {
    heading: 'Median Age',
    omissions: ['Median Age', 'Average Age'],
  },
  'Value of Owner Occupied Housing Units': {
    heading: 'Median Value',
    omissions: ['Median Value', 'Average Value'],
  },
  'Household Income': {
    heading: 'Median Household income',
    omissions: ['Median Household income', 'Average Household Income'],
  },
  'Travel Time to Work': {
    heading: 'Average Travel Time',
    omissions: ['Average Travel Time'],
  },
}
export const NATIONAL_AVG_MAPPINGS: Record<string, Record<string, string>> = {
  'General Overview': {
    Population: 'cy_pop_c',
    'Age 0 - 4': 'cy_pop_0_4_c',
    'Age 5 - 9': 'cy_pop_5_9_c',
    'Age 10 - 14': 'cy_pop_10_14c',
    'Age 15 - 17': 'cy_pop_15_17c',
    'Age 18 - 20': 'cy_pop_18_20c',
    'Age 21 - 24': 'cy_pop_21_24c',
    'Age 25 - 34': 'cy_pop_25_34c',
    'Age 35 - 44': 'cy_pop_35_44c',
    'Age 45 - 54': 'cy_pop_45_54c',
    'Age 55 - 64': 'cy_pop_55_64c',
    'Age 65 - 74': 'cy_pop_65_74c',
    'Age 75 - 84': 'cy_pop_75_84c',
    'Age 85+': 'cy_pop_85p_c',
  },
  Overview: {
    Population: 'cy_pop_c',
  },
  Households: {
    'Total Households': 'cy_househldsc',
    'Nonfamily Households': 'cy_nonfam_c',
  },
  'Housing Units': {
    'Total Housing Units': 'cy_h_units_c',
    'Vacant Housing Units': 'cy_vacunits_c',
    'Renter Occupied Housing Units': 'cy_renter_c',
    'Owner Occupied Housing Units': 'cy_owner_c',
  },
  Gender: {
    Male: 'cy_males_c',
    Female: 'cy_females_c',
  },
  Ethnicity: {
    White: 'cy_white_c',
    Black: 'cy_black_c',
    'American Indian': 'cy_indian_c',
    Asian: 'cy_asian_c',
    'Native Hawaiian / Pacific Islander': 'cy_pi_c',
    Other: 'cy_other_c',
    '2+ Races': 'cy_two_plus_c',
    '% Hispanic': 'cy_hispanic_c',
  },
  Age: {
    'Age 0 - 4': 'cy_pop_0_4_c',
    'Age 5 - 9': 'cy_pop_5_9_c',
    'Age 10 - 14': 'cy_pop_10_14c',
    'Age 15 - 17': 'cy_pop_15_17c',
    'Age 18 - 20': 'cy_pop_18_20c',
    'Age 21 - 24': 'cy_pop_21_24c',
    'Age 25 - 34': 'cy_pop_25_34c',
    'Age 35 - 44': 'cy_pop_35_44c',
    'Age 45 - 54': 'cy_pop_45_54c',
    'Age 55 - 64': 'cy_pop_55_64c',
    'Age 65 - 74': 'cy_pop_65_74c',
    'Age 75 - 84': 'cy_pop_75_84c',
    'Age 85+': 'cy_pop_85p_c',
  },
  'Marital Status': {
    'Never Married': 'cy_ms_never_c',
    'Married, Spouse Present': 'cy_ms_mar_spc',
    'Married, Spouse Absent': 'cy_ms_mar_sac',
    Divorced: 'cy_ms_divrc_c',
    Widowed: 'cy_ms_widow_c',
  },
  'Value of Owner Occupied Housing Units': {
    '< $20,000': 'cy_val_lt_20c',
    '$20,000 - $39,999': 'cy_val_20_40c',
    '$40,000 - $59,999': 'cy_val_40_60c',
    '$60,000 - $79,999': 'cy_val_60_80c',
    '$80,000 - $99,999': 'cy_val_80_99c',
    '$100,000 - $149,999': 'cy_val100150c',
    '$150,000 - $199,999': 'cy_val150200c',
    '$200,000 - $299,999': 'cy_val200300c',
    '$300,000 - $399,999': 'cy_val300400c',
    '$400,000 - $499,999': 'cy_val400500c',
    '$500,000 - $749,999': 'cy_val500750c',
    '$750,000 - $999,999': 'cy_val7501mlc',
    '$1,000,000 - $1,499,999': 'cy_val1m1p5mc',
    '$1,500,000 - $1,999,999': 'cy_val1p5m2mc',
    '$2,000,000+': 'cy_val_2milpc',
  },
  'Types of Housing Units': {
    'Single Unit Detached': 'cy_units1detc',
    'Single Unit Attached': 'cy_units1attc',
    '2 Units': 'cy_units_2_c',
    '3 to 4 Units': 'cy_units_3_4c',
    '5 to 19 Units': 'cy_units5_19c',
    '20 to 49 Units': 'cy_units2049c',
    '50+ Units': 'cy_units_50pc',
    'Mobile Home': 'cy_mobilehomc',
    Other: 'cy_unitsothrc',
  },
  'Household Income': {
    '<$15,000': 'cy_hi_l15_c',
    '$15,000-$24,999': 'cy_hi_15_25_c',
    '$25,000-$34,999': 'cy_hi_25_35_c',
    '$35,000-$49,999': 'cy_hi_35_50_c',
    '$50,000-$74,999': 'cy_hi_50_75_c',
    '$75,000-$99,999': 'cy_hi_75_100c',
    '$100,000-$124,999': 'cy_hi100_125c',
    '$125,000-$149,999': 'cy_hi125_150c',
    '$150,000-$199,999': 'cy_hi150_200c',
    '$200,000-$249,999': 'cy_hi200_250c',
    '$250,000-$499,999': 'cy_hi250_500c',
    '$500,000+': 'cy_hi_500p_c',
  },
  Education: {
    '< 9th Grade': 'cy_edu_l9_c',
    'No High School Degree': 'cy_edu_sm_hsc',
    'High School Graduate': 'cy_edu_hs_c',
    'Some College, No Degree': 'cy_edu_smcolc',
    "Associate's Degree": 'cy_edu_as_c',
    "Bachelor's Degree": 'cy_edu_ba_c',
    "Master's Degree": 'cy_edu_mast_c',
    'Professional Degree': 'cy_edu_prof_c',
    'Doctorate Degree': 'cy_edu_doct_c',
  },
  'Labor Force': {
    'Civilian Labor Force, Employed': 'cy_lf_emp_c',
    'Civilian Labor Force, Unemployed': 'cy_lf_unemp_c',
    'Armed Forces': 'cy_lf_armf_c',
    'Not in Labor Force': 'cy_lf_notilfc',
  },
  'Transportation to Work': {
    'Worked at Home': 'cy_trn_home_c',
    Walked: 'cy_trn_walk_c',
    Bicycle: 'cy_trn_bike_c',
    Carpooled: 'cy_trn_pool_c',
    'Drove Alone': 'cy_trn_drivec',
    'Public Transport': 'cy_trnpublicc',
    Other: 'cy_trn_otherc',
  },
  'Travel Time to Work': {
    'Travel Time: < 15 Minutes': 'cy_trvl_l15_c',
    'Travel Time: 15 - 29 Minutes': 'cy_trvl15_29c',
    'Travel Time: 30 - 44 Minutes': 'cy_trvl30_44c',
    'Travel Time: 45 - 59 Minutes': 'cy_trvl45_59c',
    'Travel Time: 60+ Minutes': 'cy_trvl_60p_c',
  },
  'Population by Industry': {
    'Accommdtn/Food Svcs': 'cy_ind_accomc',
    'Admin/Spprt/Waste Mgmt': 'cy_ind_adminc',
    'Agriculture/Forest/Fish/Hunt/Mine': 'cy_indagffhmc',
    'Entertainment/Rec': 'cy_ind_arts_c',
    Construction: 'cy_ind_cnstrc',
    'Educational Svcs': 'cy_indeducatc',
    'Fin/Insur/RE/Rent/Lse': 'cy_indfintotc',
    'Health Care/Soc Asst': 'cy_indhealthc',
    Information: 'cy_indinformc',
    'Mgmt of Companies': 'cy_ind_mgmntc',
    'Total Manufacturing': 'cy_ind_manufc',
    'Oth Svcs, Not Pub Admin': 'cy_indothrsvc',
    'Prof/Sci/Tech/Admin': 'cy_indproscic',
    'Public Administration': 'cy_indpubadmc',
    'Retail Trade': 'cy_indretailc',
    'Transport/Warehse/Utils': 'cy_indtransuc',
    'Wholesale Trade': 'cy_ind_whlslc',
  },
  'Population by Occupation': {
    'Architect/Engineer': 'cy_oc_arcengc',
    'Arts/Entertain/Sports': 'cy_oc_arts_c',
    'Building Grounds Maint': 'cy_oc_bldmntc',
    'Business/Financial Ops': 'cy_oc_busop_c',
    'Community/Soc Svcs': 'cy_oc_commssc',
    'Computer/Mathematical': 'cy_oc_cmpmthc',
    'Construction/Extraction': 'cy_oc_consexc',
    'Edu/Training/Library': 'cy_oc_edtrnlc',
    'Farm/Fish/Forestry': 'cy_oc_farmffc',
    'Food Prep/Serving': 'cy_oc_food_c',
    'Health Practitioner/Tec': 'cy_oc_hlthptc',
    'Healthcare Support': 'cy_oc_hlths_c',
    'Maintenance Repair': 'cy_oc_instalc',
    Legal: 'cy_oc_legal_c',
    'Life/Phys/Soc Science': 'cy_oc_lifesic',
    Management: 'cy_oc_mgmt_c',
    'Office/Admin Support': 'cy_oc_officec',
    Production: 'cy_oc_prod_c',
    'Protective Svcs': 'cy_oc_protsvc',
    'Sales/Related': 'cy_oc_sales_c',
    'Personal Care/Svc': 'cy_oc_persvcc',
    'Transportation/Moving': 'cy_oc_trans_c',
    'White Collar': 'cy_oc_white_c',
    'Blue Collar': 'cy_oc_blue_c',
    'Service & Farm': 'cy_oc_srvc_fc',
  },
  'Overall average annual household expenditure': {
    food: 'cy_foodto',
    alcohol: 'cy_alcbev',
    housing: 'cy_housin',
    apparel: 'cy_appare',
    transportation: 'cy_trans',
    health: 'cy_health',
    entertainment: 'cy_entrta',
    personal_care: 'cy_persca',
    reading: 'cy_readin',
    education: 'cy_educat',
    tobacco: 'cy_tobacc',
    misc: 'cy_misc',
    cash: 'cy_cashco',
    insurance: 'cy_inspen',
    total: 'cy_totale',
    total_retail: 'cy_tr',
    total_non_retail: 'cy_tnr',
  },
}
